import Realm from 'realm';
import {
    LatestAcks,
    ChatList,
    SchemaTypeMaps,
    Message,
    MessageMeta,
    VersionConfig,
    VersionConfigSchema,
} from './schema';

import {
    FriendList, GroupSendMsg,
    GroupChatList,
    MemberAvatarList,
    UserList
} from "./contactSchema";

type SchemaNames = keyof SchemaTypeMaps;
// Web 端用 IndexedDB 封装，兼容 Realm API
import * as webdb from './webdb';

let realm: Realm | null = null;

export const currentRealm = () => {
    // 兼容 objectForPrimaryKey
    return {
        ...webdb,
        objectForPrimaryKey: webdb.objectForPrimaryKey,
    };
};

export const getData = <T extends SchemaNames>(database: T) => {
    return webdb.objects(database);
};

export const setData = <T extends SchemaNames>(
    database: T,
    data: SchemaTypeMaps[T],
) => {
    return webdb.write(async () => {
        await webdb.create(database, data);
        console.log('wirte databse: ', database);
    });
};

export const closeRealm = () => {
    return webdb.close();
};

export const getConfig = async () => {
    const all = await getData('VersionConfig');
    const config = all.find(({version}) => version === 1);
    if (!config) {
        const defaultConf = {version: 1, sid: 0, aid: 0};
        await setData('VersionConfig', defaultConf);
        return defaultConf;
    }
    return config;
};
export const setConfig = async (config: VersionConfigSchema) => {
    const all = await getData('VersionConfig');
    const currConf = all.find(({version}) => version === 1);
    if (!currConf) {
        await setData('VersionConfig', {version: 1, sid: 0, aid: 0, ...config});
        return;
    }
    await setData('VersionConfig', { ...currConf, ...config });
};

export const cleanSchema = async () => {
    await Promise.all([
        webdb.deleteAll('ChatList'),
        webdb.deleteAll('VersionConfig'),
        webdb.deleteAll('UserList'),
        webdb.deleteAll('FriendList'),
        webdb.deleteAll('GroupChatList'),
        webdb.deleteAll('MemberAvatarList'),
        webdb.deleteAll('GroupSendMsg'),
        webdb.deleteAll('Message'),
    ]);
};

